export default "__VITE_ASSET__Chgrjl7R__"